module.exports = {
  label: {
    title: 'Ooops!',
    message: "Page not found. Don't worry though, we have plenty of other pages to explore",
    buttons: {
      back: 'Back',
      home: 'Home'
    }
  }
}